import { render, staticRenderFns } from "./cms-block-youtube-video.vue?vue&type=template&id=14a67022&scoped=true"
import script from "./cms-block-youtube-video.vue?vue&type=script&lang=js"
export * from "./cms-block-youtube-video.vue?vue&type=script&lang=js"
import style0 from "./cms-block-youtube-video.vue?vue&type=style&index=0&id=14a67022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a67022",
  null
  
)

export default component.exports